// @ts-nocheck

import NumberFormatter from '../i18n/numberformatter';
import { PresentationDefaultPositions } from '../types/betGroup';

import { specifiersToHash } from './bet';
import { getNumberOfDecimals } from './number';

export const getStartPosition = (length, defaultPosition) => {
  if (!length) {
    return 0;
  }

  if (defaultPosition === PresentationDefaultPositions.MIDDLE) {
    return Math.floor((length + 1) / 2) - 1;
  }
  return 0;
};

export const formatSpecifier = (specifiers, specifier) => {
  const specifiersHash = specifier ? specifiersToHash(specifiers) : null;
  const label = specifiersHash?.[specifier];

  if (!isNaN(+label)) {
    const decimals = getNumberOfDecimals(label);
    return NumberFormatter.format(+label, null, false, decimals, true);
  }
  return label || '';
};
